
    <div class="layout-wrapper">
        <app-dashboard-topbar />
        <div class="layout-sidebar bg-surface-0 dark:bg-surface-900">
            <app-dashboard-sidebar/>
        </div>
        <div class="layout-main-container bg-primary-50 dark:bg-surface-950">
            <div class="layout-main py-10 lg:px-10">
                <router-outlet></router-outlet>
            </div>
        </div>
        <div class="layout-mask"></div>
    </div>
 <p-toast position="top-center" key="global" [baseZIndex]="5000">
    </p-toast>



